import { SamwinCallInfoRemoteDto } from '../../../../generated/signalR/samwin-call-info-remote-dto';
import { Skill } from '../samwin-skills/skill';

export class CallListChanged {
   public static readonly type = '[Samwin CallList] call list changed';

   constructor(public updatedCallList: SamwinCallInfoRemoteDto[]) {}
}

export class UpdatePreviousCall {
   public static readonly type = '[Samwin CallList] update previous call';

   constructor(public currentCallRemoteDto: SamwinCallInfoRemoteDto) {}
}

export class SkillFilterChanged {
   public static readonly type = '[Samwin CallList] skill filter changed';

   constructor(public skill: Skill) {}
}
